import keywordPlannerResource from './resource';
import negativeKeyword from '../shared/resource/negative-keywords';
import bids from '../shared/resource/bids';
import errorTransformer from '../shared/transformers/errorTransformer';
import transformToCamelCase from '../shared/transformers/toCamelCaseTransformer';

function getKeywordPlannerInsight({ limit, offset, selectedQueries }) {
  return keywordPlannerResource
    .getKeywordPlannerInsight(
      {},
      {
        queries: selectedQueries,
        limit,
        offset,
        ordering: 'rate',
        reverse: true,
      },
    )
    .then(({ body }) => transformToCamelCase(body))
    .catch(errorTransformer);
}

function addBulkBids({ campaignId, queries, matchType, price }) {
  const transformedBids = queries.map(query => ({
    query,
    matchingType: matchType,
    priceOffer: price,
  }));

  return bids.addBulkBids({
    campaignId,
    bids: transformedBids,
    referrer: 'keyword-planner',
  });
}

function addBulkNegativeKeyword({ campaignId, queries }) {
  const transformedQueries = queries.map(query => ({ keyword: query }));

  return negativeKeyword.addBulkNegativeKeyword({
    campaignId,
    negativeKeywords: transformedQueries,
  });
}

export default {
  getKeywordPlannerInsight,
  addBulkBids,
  addBulkNegativeKeyword,
};
